


















import OccButton from "@/components/Atoms/OccButton/index.vue";
import { defineComponent } from "@vue/composition-api";
import { occPrimary } from "@/assets/styles/vars-for-script.scss";

export default defineComponent({
  components: {
    OccButton
  },
  name: "FieldAddButton",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    gaEventCategory: {
      type: String,
      default: ""
    }
  },
  emits: ["click"],
  setup() {
    return { occPrimary };
  }
});
